module.exports = __webpack_public_path__ + "static/media/geriatric-health-services.464bd741.jpg";